import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import * as d3 from 'd3';
import { getGradeRange, roundTwoDigits } from '@/utils/utils';
import { findPercentage } from '@/utils/math';

@Component({
    name: 'atc-chart',
})

export default class AtcChart extends Vue {

  // ------------------------------------------------------------------------
  // Properties
  @Prop()
  private dataList: any;

  private activeStudent: any = null;

  public getPercentage(obtained: number, total: number) {
    return findPercentage(obtained, total);
  }

  public roundTwoDigits(num: number) {
    return roundTwoDigits(num);
  }

  @Watch('dataList', {deep: true})
  private watchData(value: any) {
    this.drawAtcChart(value);
  }

  // ------------------------------------------------------------------------
  // Hooks
  private mounted() {
    this.drawAtcChart(this.dataList);
  }


  // -------------------------------------------------------------------------
  // Methods
  private drawAtcChart(dataset: any) {
    d3.select(this.$el).select('svg').remove();
    const margin = {
        top: 30,
        right: 20,
        bottom: 30,
        left: 50,
      };
    const width = this.$el.clientWidth - margin.left - margin.right;
    const height = 200 - margin.top - margin.bottom;

    const xScale = d3.scaleLinear()
      .domain([
        0,
        d3.max(dataset, (d: any) => d.masteredCompetencies / 5 + d.masteredCompetencies as number) as number + 10,
      ])
      .range([0, width]);

    const yScale = d3.scaleLinear()
      .domain([0, 100])
      .range([height, 0]);

    const xAxis = d3
      .axisBottom(xScale)
      .tickPadding(15);

    const yAxis = d3
      .axisLeft(yScale)
      .ticks(5)
      .tickSize(-width)
      .tickPadding(10)
      .tickFormat((d) => d + '%');

    const svg = d3
      .select(this.$el)
      .append('svg')
      .attr('class', 'navigator-atc-chart')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom + 21)
      .append('g')
      .attr('transform', `translate(${margin.left},${margin.top})`);

    svg
      .append('g')
      .attr('class', 'x axis')
      .attr('transform', `translate(0,${height})`)
      .call(xAxis);

    svg
      .append('g')
      .attr('class', 'y axis')
      .call(yAxis);

    const studentNode = svg
      .selectAll('.student-nodes')
      .data(dataset)
      .enter()
      .append('g')
      .attr('transform', (d: any) => {
        return `translate(${xScale(d.masteredCompetencies)}, ${yScale(d.averagePerformance)})`;
      })
      .attr('class', (d: any) => {
        return `node-point-${d.seq}`;
      })
      .on('mousemove', (d: any) => {
        this.activeStudent = d;
        const clientY = d3.event.clientY;
        const clientX = d3.event.clientX;
        let top = clientY > 420 ? clientY - 185 : clientY;
        let left = clientX > 600 ? clientX - 225 : clientX;
        top = d3.event.pageY;
        left = d3.event.pageX;
        // top = d3.event.offsetY + 10;
        // left = d3.event.offsetX + 10;
        const tooltipPos = {
          top: `${top}px`,
          left: `${left}px`,
        };
        this.activeStudent.style = tooltipPos;
      })
      .on('mouseleave', (d: any) => {
        this.activeStudent = null;
      });

    studentNode
      .append('circle')
      .attr('cx', 12)
      .attr('cy', 12)
      .attr('r', 16)
      .attr('class', (d: any) => `fill-range-${getGradeRange(d.averagePerformance)}`);

    studentNode
      .append('svg:image')
      .attr('class', 'student-profile')
      .attr('x', 0)
      .attr('y', 0)
      .attr('xlink:href' , (d: any) => {
          return d.thumbnailUrl;
        })
        .attr('width', 24)
        .attr('height', 24);

    svg
    .append('g')
    .attr('transform', 'translate(-485, 195) rotate(-90)')
    .append('text')
    .attr('class', 'placeholder')
    .attr('x', '50')
    .attr('y', '445')
    .text('Performance');

    svg
    .append('g')
    .attr('transform', 'translate(5, 45) rotate(0)')
    .append('text')
    .attr('class', 'placeholder')
    .attr('x', '0')
    .attr('y', height)
    .text('Competencies');
  }
}
